import { createGlobalStyle } from 'styled-components';

// Global styles:
import { BurgerStyle } from './Burger';
import { ReactHintStyles } from './ReactHint';

export const GlobalStyle = createGlobalStyle`
  body {
    width: 100%;
    min-width: 234px;
    max-width: 100vw;
    scroll-behavior: smooth;
  }

  ${BurgerStyle}

  ${ReactHintStyles}
  
  .header_right-side {
    align-items: center;
  }

  * {
    box-sizing: border-box;
  }

  button {
    -webkit-tap-highlight-color: transparent;
  }

  input[type='radio'] {
    margin-right: 8px;
    border-radius: 50%;
  }

  div:not(.lt-widget-wrapper) {
    input[type='radio'],
    & > input[type='checkbox'] {
      margin: 0;
      background: none;
      border: 0;
      box-shadow: none;
    }

    input[type='radio'] {
      margin-right: 8px;
      border-radius: 50%;
    }

    & > input[type='checkbox']:checked,
    & > input[type='checkbox']:checked:active {
      background: none;
    }
  }
`;
